/**
 * this file is used for both section Avm Lead Analysis and Contact Analysis
 * @typedef {Object} Props
 * @property {string} titleKey - Translation key for title
 * @property {string} descriptionKey - Translation key for description
 */

import { translate } from '../../../../Internationalization';
import React from 'react';

/** @extends {React.Component<Props>} */
export default class GenericMoversOverlay extends React.Component {
	/** @returns {string} */
	static #getTenant() {
		const host = window.location.hostname.toLowerCase();
		if (host.includes('simplyhome')) {
			return translate('global.tenants.simplyhome');
		}
		return translate('global.tenants.homekeepr'); // safe default
	}

	/**
	 * @returns {JSX.Element}
	 */
	/* eslint-disable class-methods-use-this -- Render method must be invokable by `this` */
	render() {
		return (
			<section className="md:flex justify-between mt-2">
				<article className="mr-4">
					<p className="h-ms-4">{translate(this.props.titleKey)}</p>
					<p
						className="text-sm mt-2"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: translate(
								this.props.descriptionKey,
								GenericMoversOverlay.#getTenant(),
								GenericMoversOverlay.#getTenant()
							),
						}}
					/>
				</article>
			</section>
		);
	}
}
